import React from 'react';
import { memoize } from 'lodash';
/* eslint-disable import/prefer-default-export */

/**
 * Transforms a string to replace asterisks with specified separator. Generally used to
 * format product name (e.g., 'Stay Hot Keep Cold Bottle *19oz').
 * @param {String} text
 * @param {String} separator
 * @return {String}
 */
export var convertAsterisk = function () {
  var text = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var separator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return text.split('*').join(separator);
};